import React, { useEffect, useContext } from 'react';
import styled from 'styled-components/macro';
import { TextField as MuiTextField, makeStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import MinimalSelect from '../ui/MinimalSelect';
import EditorContext from '../../modules/contexts/editor';
import { sizes } from '../../modules/defines/style';

import deletePNG from '../../assets/images/delete.png';
import Button from "@material-ui/core/Button";

export const PropSheet = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    // padding: 0px 4px 6px 4px;
    overflow-y: auto;
    overflow-x: hidden;
`;

export const PropSheetTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 3px 0;
    margin-bottom: 4px;
    font-size: 12px;
    font-weight: 600;
    background-color: #e8e7e7;
    text-transform: capitalize;
`;

export const Field = styled.div`
    display: flex;
    flex-direction: row;
    margin: 4px 6px 8px 6px;
`;

const SelectFieldWrapper = styled.div`
    width: 90%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
`;
const SelectFieldLabel = styled.div`
    padding: 0 8px 0 7px;
`;

const CheckBoxFieldRow = styled(Field)`
    align-items: center;
`;
const FieldCheckbox = styled(Checkbox)`
    width: 11px;
    height: 0px;
    color: #9a9a9a !important;
`;
const Label = styled.div`
    //width: 80px;
    padding: 0 4px 0 0;
    text-align: right;
`;

export const CheckboxField = ({ label, checked, disabled, onChange, style }) => (
    <CheckBoxFieldRow style={style}>
        <Label>{label}</Label>
        <FieldCheckbox  size='small' checked={checked} disabled={disabled} onChange={onChange}/>
    </CheckBoxFieldRow>
);


export const SelectField = ({ label, value, onSelect, options, placeHolder }) => (
    <SelectFieldWrapper>
        { label && <SelectFieldLabel>{label}:</SelectFieldLabel> }
        <MinimalSelect options={options} value={value} onSelect={onSelect} placeHolder={placeHolder} />
    </SelectFieldWrapper>
);

const useTextClasses = makeStyles({
    root: {
        width: '100%',
        fontSize: (props) => props.fontSize || 'inherit',
    },
    form: {
        marginTop: '11px !important',
    },
    underline: {
        borderBottom: '1px solid rgb(250 250 250)'
    }
});

export const TextAreaField = (props) => {
    const textClasses = useTextClasses();
    return (
        <Field style={{ width: props.width || "100%" }}>
            <MuiTextField
                multiline variant="outlined" maxRows={4}
                classes={{ root: textClasses.root }} InputProps={{ defaultValue: props.defaultValue }}
                {...props}
            />
        </Field>
    );
};

export const TextField = (props) => {
    const textClasses = useTextClasses(props);
    return (
        <Field>
            <MuiTextField classes={{ root: textClasses.root }} InputProps={{ defaultValue: props.defaultValue }} {...props} />
        </Field>
    );
};

export const OptionSelect = ({ node, field, onSelect, placeHolder, style = {} }) => {
    return (
        <SelectFieldWrapper style={style}>
            { field.label && <SelectFieldLabel>{field.label}:</SelectFieldLabel> }
            <MinimalSelect options={field.choices} value={field.value} onSelect={onSelect} placeHolder={placeHolder} />
        </SelectFieldWrapper>
    );
};

const useButtonClasses = makeStyles({
    root: {
        background: (props => props.defaultBtn ? '#b3cbff8f' : 'inherit'),
        '&:hover': {
            background: (props => props.defaultBtn ? 'rgba(91,142,255,0.56)' : 'inherit'),
        }
    },
    outlined: {
        padding: '0px 10px',
        fontSize: 12,
        textTransform: 'none',
    },
});

export const SmallButton = ({ children, onClick, defaultBtn, disabled }) => {
    const buttonClasses = useButtonClasses({ defaultBtn });
    return (
        <Button variant="outlined" classes={buttonClasses} disabled={disabled} onClick={onClick}>{children}</Button>
    );
}
